import * as API from 'src/helpers/api_helper'
import * as URL from 'src/helpers/url_helper'

export const AdminSanctionProcessFeesListApi = (data) =>
    API.get(`${URL.ADMIN_SANCTION_PROCESSING_FEE}`, data)
